
import React from 'react';
export default function Blog003() {
  return (
    <section>
    <article>
      <h2>3. 08-08-2022</h2>
      <h3>Pair Programming and Side Project Opportunities </h3>
      <p>
        Yesterday, I had layed out my plan to create the project. 
        I decided to take a break before I got started building it.
        Right before I took a break I decided to check around on discord.
        [I have recently read about pair programming. and was excited to implement the practice]
        My expectation was low, I honestly thought I would put a message out there
        seeking like-minded folks to pair program. I posted in a few coding groups on Discord.
        <br />
        Before I was able to get up and continue on to my break I had planned earlier, I received a reply 
        "sure". This was unexpected, and exciting. I message the person directly, a few questions later, 
        I am sharing my screen, explaining this project that I am going to try to build.
        This person has a CS degree and 10 years of experience with an extended knowledge of Javascript.
        It was fun to teach them a thing or two about CSS. I learned a crazy amount from them. 
        We built the app about 20% and I decided I would like to know more on javascript before continuing. 
        We had been going for a few hours at this point. <br />
        Since our interaction, I have been studying and changing the code. <br />
        We had button one set to reveal [0] in the array.
        I set button 2 to [1], and 3 to [2]. Now revealing the corresponding text to each button and text area.
        I touched up the CSS to make it look nice. I saw an opportunity: This game
        as-is, would be a functional text-reveal to button. Check out the links below to see <strong>exactly</strong>
        what I am talking about. <br />In conclusion:
        </p>
        <ul>
          <li>I have learned what it is like to pair-program with someone</li>
          <li>I started coding my text game project</li>
          <li>I created a webpage with interactive buttons</li>
        </ul>

        
     
    </article>

    <h4>Links</h4>
    <br />
    <ul>
      <li>
        <a
          href="https://ericpolley.github.io/button_reveal_text/"
          title="Web page I created"
        >
          <strong><p>Web Page: Button onclick = Text Section</p></strong></a
        >
      </li>
    </ul>
  </section>
  )
}
